"use client";

import { useCartMerge } from "@/features/cart/hooks/use-cart-merge";
import { useSyncLastCartId } from "@/features/cart/hooks/use-sync-last-cart-id";

export const CartMergeHandler = () => {
  useCartMerge();
  useSyncLastCartId();
  return null;
};
